// extracted by mini-css-extract-plugin
module.exports = {"faqHolder":"SupportSidebar_faqHolder__3Vy0C"};